<style scoped lang="scss">
  .wrap-primer{
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title{
      h3{
        font-size: 24px;
        font-weight: bold;
      }
    }
    .el-steps{
      width:400px;
    }
    .edit-form{
      border:1px solid #E4E6EA;
      min-height: 635px;
      .title{
        background: #F6FAFD;
        padding:20px;
        span{
          margin-right:5px;
        }
      }
      .con{
        padding:15px;
      }
      h4{
        font-size: 16px;
        margin-top:40px;
        margin-bottom: 10px;
        font-weight: normal;
        &:first-child{
          margin-top: 0;
        }
      }
    }
    .table-opera{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 20px;
    }
    .other-methods{
      margin-top:30px;
      span{
        color: #014492;
      }
      li{
        display: flex;
        align-items: center;
        margin-bottom:3px;
        background: #F9F9F9;
        label{
          display: flex;
          align-items: center;
          justify-content: center;
          color:#fff;
          background: #014492;
          width:140px;
          padding:10px 0;
          margin-right: 30px;
          img{
            margin-right: 10px;
          }
        }
      }
    }
  }
  .el-row{
    position: static;
  }
  .sample-table{
    position: relative;
    .operate{
      position: absolute;
      right:1px;
      top: 56px;
      text-align: center;
      z-index: 98;
      width:8.8%;
      height:410px!important;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color:#014492;
      cursor: pointer;
      &.more-lines{
        width:19.4%;
        right:15px;
      }
    }
  }
  .tooltip{
    position: absolute;
    z-index: 0;
    background: #fff;
    border:1px solid #eee;
    padding:10px;
    width:140px;
    left:230px;
    display: none;
    box-shadow: 0 2px 3px rgba(0,0,0,.2);
  }
  .sample-table{
    position: relative;
  }
</style>
<style lang="scss">
  .edit-form{
    .el-input-group__append{
      width:80px;
    }
  }
  .dialog-map{
    .el-dialog{
      background: none;
      box-shadow: none;
      .close{
        position: absolute;
        right:20px;
        top:20px;
        font-size: 24px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
</style>
<template>
  <div class="wrap wrap-primer" v-loading="submitLoading">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>基因合成在线订购</h3>
          <p class="pointer" v-show="unCompleteOrders > 0" @click="toOrders">未处理订单（<span class="text-primary">{{unCompleteOrders}}</span>）</p>
        </div>
        <el-steps :active="0" finish-status="success" align-center>
          <el-step title="序列输入、定制化信息填写"></el-step>
          <el-step title="报价并确认订单"></el-step>
        </el-steps>
      </div>
      <el-row :gutter="40" class="mt50">
        <el-col :span="15">
          <div class="mb10">
            <span class="fb fz16 mr20">基因名称及序列</span>
            <el-radio-group v-model="cloneRadio">
              <el-radio label="1" @change="changeCloneMethod1($event)">每个基因克隆信息一致</el-radio>
              <el-radio label="2" @change="changeCloneMethod2($event)">每个基因克隆信息不一致</el-radio>
            </el-radio-group>
          </div>
          <div>
          </div>
          <div
            class="sample-table">
            <div class="col-header">
              <span :style="{ width: hotSettings.colWidths[0] }" style="font-size: 12px;margin-top: 8px;">
                <input type="checkbox" @click="checkboxOnclick($event)"/>
              </span>
              <span :style="{ width: hotSettings.colWidths[1] }" style="margin-top: 8px;font-weight:bold;">序号</span>
              <span :style="{ width: hotSettings.colWidths[2] }" style="margin-top: 8px;font-weight:bold;">
                <i style="color: red">*</i>
                基因名称
              </span>
              <span :style="{ width: hotSettings.colWidths[3] }" style="margin-top: 8px;font-weight:bold;">
                <i style="color: red">*</i>
                基因序列
                <el-tooltip placement="top">
                    <div slot="content" style="text-align: justify;">
                        请在基因两端或5’，3’ 加入克隆位点，或者<br/>
                        我们会在第二步根据您选择的酶切位点自动添<br/>
                        加。 蛋白序列请用单字母， *表示终止密码<br/>
                        子。
                       </div>
                   <i class="iconfont icon-wenhao" style="color: #409EFF;font-weight:bold;"></i>
                </el-tooltip>
              </span>
              <span :style="{ width: hotSettings.colWidths[4] }" style="font-weight:bold;">
                5‘侧翼序列 <br>（仅限DNA序列)
                <el-tooltip placement="top">
                    <div slot="content" style="text-align: justify;">
                        如果您需要优化您的基因,<br/>
                        侧翼序列将不会被优化
                       </div>
                  <i class="iconfont icon-wenhao" style="color: #409EFF;font-weight:bold;position: relative;left: 0;top: -3px;"></i>
                </el-tooltip>
              </span>
              <span :style="{ width: hotSettings.colWidths[5] }" style="font-weight:bold;">
                3‘侧翼序列 <br>（仅限DNA序列)
                <el-tooltip placement="top">
                    <div slot="content" style="text-align: justify;">
                        如果您需要优化您的基因,<br/>
                        侧翼序列将不会被优化
                       </div>
                  <i class="iconfont icon-wenhao" style="color: #409EFF;font-weight:bold;position: relative;left: 0;top: -3px;"></i>
                </el-tooltip>
              </span>
              <span :style="{ width: hotSettings.colWidths[6] }" style="margin-top: 8px;font-weight:bold;">
					  序列类型
				  </span>
              <span :style="{ width: hotSettings.colWidths[7] }" style="margin-top: 8px;font-weight:bold;">长度</span>
              <span :style="{ width: hotSettings.colWidths[8] }" style="margin-top: 8px;font-weight:bold;" v-if="cloneRadio === '2'">定制化</span>
            </div>
            <hot-table ref="hotTable"  :settings="hotSettings" class="hot-table" :licenseKey="licenseKey"></hot-table>
<!--            <div class="operate" style="cursor: auto!important;" :class="{'more-lines' : useRows > 10}" :style="{height: useRows < 10 ? `${41 * useRows}px` : '410px'}" v-show="cloneRadio === '1' && hotSettings.data.length > 0" ></div>-->
            <div class="table-none" v-show="hotSettings.data.length === 0">暂无数据</div>
            <div class="tooltip" id="tooltip"></div>
          </div>
          <div class="table-opera">
            <el-form :inline="true">
              <el-form-item label="基因条数：">
                <el-input v-model="addRows" type="number" @input="inputGeneNum"/>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="handleUsePrimers">应用</el-button>
              </el-form-item>
            </el-form>
            <el-button @click="clearTable" >清空表格</el-button>
            <el-button @click="deleteSelect" >批量删除</el-button>
          </div>
          <el-input
            type="textarea"
            :rows="5"
            maxlength="100"
            placeholder="请输入订单备注"
            v-model="remark"></el-input>
          <div class="tr">
            <el-button type="primary" class="mt20 " @click="onsubmit" v-preventReClick>提交并确认订单，查看订单价格</el-button>
          </div>
          <div class="other-methods">
            <h4 class="fz16">其他订购方式</h4>
            <p class="mt20">使用擎科生物的<span>在线订购系统</span>，可在在线下单，便捷查询合成进度。<br>
              如在线订购系统不能满足您的下单需求，请下载<a href="https://geartest.oss-cn-beijing.aliyuncs.com/tsingke/config/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.docx">电子订单</a>，并发送至基因合成实验室邮箱我们
              将及时回复您的需求。</p>
            <ul class="mt20">
              <li>
                <label><img src="@/assets/images/icon_tel.png"> 电话</label>
                <!-- <span>400-668-3730转 3</span> -->
                <span>400-668-3730</span>
              </li>
              <li>
                <label><img src="@/assets/images/icon_down.png"> 下载</label>
                <a href="https://geartest.oss-cn-beijing.aliyuncs.com/tsingke/config/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.docx">订单下载</a>
              </li>
              <li>
                <label><img src="@/assets/images/icon_email.png"> 邮箱</label>
                <span>gene@tsingke.com.cn</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="9" style="padding-left: 0;padding-right: 0;">
          <div class="fz16 fb mb10">基因定制化信息</div>
          <div class="edit-form">
            <div class="title" v-if="currentGene >= 0 && cloneRadio === '2'">
              <span>序号：{{currentGene + 1}}</span>
              <span>基因名称：{{hotSettings.data[currentGene].name}}</span>
              <span>基因长度：{{hotSettings.data[currentGene].sequenceSize}}</span>
            </div>
<!--            <div class="title" v-else>点击左侧<span class="text-primary" style="margin-right: 0;"> 编辑 </span>按钮，编辑对应的基因的定制化信息</div>-->
            <div class="con" >
              <el-form ref="form" :model="editForm" label-width="110px">
                <h4>1、基因合成速度</h4>
                <el-form-item label-width="0">
                  <el-radio-group v-model="hotSettings.data[currentGene].geneServiceType">
                    <el-radio label="STANDARD" style="display: block" @change="geneServiceTypeChange($event)">标准基因合成</el-radio>
                    <el-radio label="SPEED" class="mt10" style="display: block" @change="geneServiceTypeChange1($event)">快速基因合成</el-radio>
                    <el-radio label="ET_GENE" class="mt10" @change="geneServiceTypeChange2($event)">ETgene</el-radio>
                  </el-radio-group>
                </el-form-item>
                <h4 style="margin-top: 15px;">2、密码子优化</h4>
                <el-form-item label-width="0">
                  <el-radio-group v-model="hotSettings.data[currentGene].codonOptimization">
                    <el-radio :label="true">是</el-radio>
                    <span v-if="cloneRadio === '2' && hotSettings.data[currentGene].sequenceType === 'PROTEIN'">
                      <el-tooltip placement="top">
                        <div slot="content" style="text-align: justify;">
                          当前录入的基因序列中存在Portein序列，密码子优化不能为否
                        </div>
                        <el-radio :label="false" class="mt10" disabled>否</el-radio>
                      </el-tooltip>
                    </span>
                    <span v-else-if="cloneRadio === '1' && hotSettings.data.some(({sequenceType}) => sequenceType === 'PROTEIN')">
                      <el-tooltip placement="top">
                        <div slot="content" style="text-align: justify;">
                          当前录入的基因序列中存在Portein序列，如需单独定制请<br/>
                          将页面切换至"每个基因克隆信息不一致"
                        </div>
                        <el-radio :label="false" class="mt10" disabled>否</el-radio>
                      </el-tooltip>
                    </span>
                    <!-- <span v-else-if="hotSettings.data[currentGene].sequenceType === 'PROTEIN'">
                        <el-radio :label="false" class="mt10" disabled>否</el-radio>
                    </span> -->
                    <span v-else>
                      <el-radio :label="false" class="mt10">否</el-radio>
                    </span>
                  </el-radio-group>
                </el-form-item>
                <div v-if="hotSettings.data[currentGene].codonOptimization">
                  <el-form-item label="表达宿主" class="suzhu">
                    <el-select v-model="hotSettings.data[currentGene].expressionHost" filterable>
                      <el-option
                        v-for="item in hosts"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="优化位置" class="weizhi">
                    <el-row class="weizhi_one">
                      <el-col :span="11" class="weizhi_one1">
                        <el-input v-model="hotSettings.data[currentGene].optimizeLocationMax" class="input-with-select">
                          <el-select v-model="editForm.speed" slot="append" placeholder="bp">
                            <el-option label="bp" value="1"></el-option>
                          </el-select>
                        </el-input>
                      </el-col>
                      <el-col class="tc" :span="2">至</el-col>
                      <el-col :span="11"  class="weizhi_one2">
                        <el-input v-model="hotSettings.data[currentGene].optimizeLocationMix" class="input-with-select">
                          <el-select v-model="editForm.speed" slot="append" placeholder="bp">
                            <el-option label="bp" value="1"></el-option>
                          </el-select>
                        </el-input>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="避免的酶切位点">
                    <el-select v-model="hotSettings.data[currentGene].avoidedRestrictionSites" filterable>
                      <el-option
                        v-for="item in sites"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="保留的酶切位点">
                    <el-select v-model="hotSettings.data[currentGene].conservedEnzymeDigestion" filterable>
                      <el-option
                        v-for="item in sites"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <h4 style="margin-top: 15px;">3、目的载体</h4>
                <el-form-item label="载体" required class="zaiti">
                  <el-select v-model="hotSettings.data[currentGene].rawCarrierId" filterable>
                    <el-option
                      v-for="item in spv"
                      :key="item.id"
                      :label="item.rawCarrierName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <span class="text-primary pointer ml20" @click="toMaps" >查看载体图谱</span>
                </el-form-item>
                <!-- <div style="font-size: 12px;color: #F56C6C;text-align: center;margin-top: 10px;" v-show="hotSettings.data[currentGene].spv === 'Other'">其他载体来源，订单无法提交，请联系gene@tsingke.com.cn</div> -->
                <el-form-item label="克隆位点" :required="hotSettings.data[currentGene].geneServiceType === 'ET_GENE'?false:true" class="kelong">
                  <el-row class="abc">
                    <el-col :span="11">
                      <el-form-item label="5'">
                        <el-select v-model="hotSettings.data[currentGene].modify5" filterable  :disabled="hotSettings.data[currentGene].geneServiceType === 'ET_GENE'">
                          <el-option
                            v-for="item in sites"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <el-form-item label="3'">
                        <el-select v-model="hotSettings.data[currentGene].modify3" filterable :disabled="hotSettings.data[currentGene].geneServiceType === 'ET_GENE'">
                          <el-option
                            v-for="item in sites"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <h4 style="margin-top: 15px;">4、交付量</h4>
                <el-form-item label-width="0" style="margin-bottom: 2px;">
                  <el-radio-group v-model="hotSettings.data[currentGene].quantity">
                    <el-radio label="1">标准交付：4μg冻干质粒+一管穿刺菌</el-radio>
                    <el-radio label="2" class="mt10" id="ETShow">定制化质粒制备（收费）</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div style="font-size: 12px;color: #F56C6C" id="ETShow1">如需质粒大提，请联系gene@tsingke.com.cn，或直接联系负责销售</div>
                <div v-show="hotSettings.data[currentGene].quantity === '2'">
                  <el-form-item label="质粒抽提的质量">
<!--                    <quality-input v-model="hotSettings.data[currentGene].deliverNum" :input-unit="'ug'" :real-unit="'ng'"></quality-input>-->
<!--                    {{hotSettings.data[currentGene].deliverNum}}-->
                    <el-select
                      value-key="title"
                      v-model="hotSettings.data[currentGene].deliveries">
                      <el-option
                        v-for="(item, index) in pageData.qualitiesOptions"
                        :key="index"
                        :label="item.title"
                        :value="item">
                        {{item.title}}
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <p class="mb10">抽提的质量等级</p>
                  <el-radio-group v-model="hotSettings.data[currentGene].plasmidLevel">
                    <el-radio label="科研级别"></el-radio><br>
                    <el-radio label="转染级别（小于0.1Eu/ug）" class="mt10"></el-radio><br>
                    <el-radio label="转染级别（小于0.01Eu/ug）" class="mt10"></el-radio><br>
                    <el-radio label="转染级别（小于0.005Eu/ug）" class="mt10"></el-radio>
                  </el-radio-group>
                </div>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </section>
    <div class="popup-delete" v-if="toggleShow" @click="delRows" :style="{top: position.top + 'px'}">
      删除选中行
    </div>
    <el-dialog
      width="880px"
      class="dialog-map"
      :show-close="false"
      :visible="geneMapVisible">
      <span class="el-icon-circle-close close" @click="geneMapVisible = false"></span>
      <el-carousel height="700px" :autoplay="false">
        <el-carousel-item v-for="item in geneMaps" :key="item.id">
          <iframe scrolling="no" width="800" height="700" :src="item.mapsFile.visitedUrl"/>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import {createLogger, mapState} from 'vuex'
import {HotTable} from '@handsontable-pro/vue'
import Handsontable from 'handsontable'
import 'handsontable-pro/dist/handsontable.full.css'
import {
  geneConfig,
  fetchRawCarrierList,
  geneMaps,
  geneOrders,
  geneOrdersDetails,
  geneOrdersLists,
  genePrice,
  geneWorkOrder
} from '@/services/api.index'
import {getLocalStr} from '../../utils/baseMethod'
import QualityInput from "../../components/qualityInput";

export default {
  name: 'OrderGene',
  components: {
    QualityInput,
    HotTable
  },
  data () {
    // 验证引物序列输入
    const validText = (val) => {
      if (!val || val === '') return
      return !/^[a-zA-Z]+$/.test(val)
    }
    const _this = this
    return {
      submitLoading: false,
      geneMapVisible: false,
      cloneRadio: '1',
      radio: '',
      addRows: 10,
      isActive:false,
      dataType:'',
      useRows: 10,
      list:'',
      rowspan: 1,
      remark: '',
      editForm: {
        speed: ''
      },
      tableData: [{num: 1}],
      currentGene: 0,
      hosts: [],
      sites: [],
      spv: [],
      position: {
        left: 0,
        top: 0
      },
      toggleShow: false,
      multipleSelection: [],
      currentRow: {},
      geneMaps: [],
      licenseKey: '4d522-5237a-55f42-6653a-d1494',
      hotSettings: {
        data: [],
        // 定义表结构
        colHeaders: false, //自定义列表头or 布尔值
        autoWrapRow: true, //自动换行
        minRows: 0, //最小行列
        minCols: 0,
        maxRows: 500,
        height:412,
        startRows: 10,
        copyable: true,
        colWidths: ['33px', '50px', '92px', '110px','128px','128px','78px', '50px', '64px'],
        stretchH: 'all',
        fillHandle: 'vertical',
        columns: [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            validator(val, callback) {
              // if (!val) return callback(false)
              let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
              if (pattern.test(val)) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'sequence',
            validator(val, callback) {
              // if (!val) return callback(false)
              // let bool = validText(val)
              // // let bool = /^[A-Za-z]+$/
              // if (!bool || (!val || val === '')) {
              //   return callback(true)
              // }
              // return callback(false)
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            },
          },
          {
            data: 'flankingSequence5',
            validator(val, callback) {
              // if (!val) return callback(false)
              // let bool = validText1(val)
              // // let bool = /^[A-Za-z]+$/
              // if (!bool || (!val || val === '')) {
              //   return callback(true)
              // }
              // return callback(false)
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence3',
            validator(val, callback) {
              // // if (!val) return callback(false)
              // let bool = validText1(val)
              // // let bool = /^[A-Za-z]+$/
              // if (!bool || (!val || val === '')) {
              //   return callback(true)
              // }
              // return callback(false)
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'sequenceType',
            source: ['DNA', 'PROTEIN'],
            // strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'sequenceSize',
            readOnly: true
          },
          {
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
              let span = document.createElement('SPAN');
              span.innerText = '编辑'
              span.className = 'pointer text-primary'
              const data = _this.hotSettings.data[row]
              Handsontable.dom.addEvent(span, 'mousedown', function(event) {
                if (data.name !== '' && data.sequence !== '') {
                  _this.currentGene = row
                } else {
                  _this.$message.error('基因名称/基因序列不能为空')
                }
              });
              Handsontable.dom.empty(td)
              td.appendChild(span)
              return td
            }
          }
        ],
        cells:(row,col,prop,newVal,rowIndex) => {
          //改变条件 文字变红
          let cell = {};
          let nowdata = this.hotSettings.data;
          let str = 'ATCG';
          if(nowdata.length){
            nowdata.map((itx,index) =>{
              if(row === index && [3, 4, 5].includes(col)){
                let checkField = 'sequence'
                switch(col) {
                  case 4:
                    checkField = 'flankingSequence5'
                    break
                  case 5:
                    checkField = 'flankingSequence3'
                    break
                  default:
                    break
                }
                if(/^[ATCG]+$/g.test(itx[checkField])){
                  cell.className = 'no-active'
                }else{
                  if(col === 3 && itx['sequenceType'] !== 'DNA'){
                    cell.className = 'no-active';
                  }else{
                    cell.className = 'active';
                  }
                }
              }
              // if( row === index && col === 3 && itx['sequenceType'] === 'DNA' && !/^[ATCG]+$/g.test(itx.sequence)){
              //   cell.className = 'active'
              // }else{
              //   cell.className = 'no-active';
              // }
              if(this.hotSettings.data[this.currentGene].geneServiceType === 'ET_GENE'){
                  if(itx.sequence.length > 3000){
                    if(row === index && col === 3 ){
                    cell.className = 'active'
                  }
                }
              }

            })
          }
          return cell
        },
        afterChange: function (changes, source) {
          let data = this.getSourceData()
          let str = 'ATCG';
          _this.useRows = data.length
          data.forEach((v, index) => {
            v.index = index + 1;
            v.odNum = v.odNum || 1;
            v.fzNum = v.fzNum || 2;
            v.prices = v.prices ? v.prices : 0;
          });
          function holeChange(change) {

            const [rowIndex, colField, oldVal, newVal] = change
            // if(colField === "sequence"  && !data[rowIndex].sequence.includes('ATCG')){
            //   data[rowIndex].sequenceType = 'PROTEIN'
            // }else{
            //   data[rowIndex].sequenceType = 'DNA'
            // }
            data.length &&
            data.forEach((v, index) => {
              if (
                      change[0] === index &&
                      change[1] === "sequence"
              ) {
                v.sequence = v.sequence.toUpperCase();
                let seStr = v.sequence;
                if(!v.sequenceType || v.sequenceType === 'DNA') {
                  v.sequenceType = /^[ATCG]+$/.test(seStr) ? 'DNA' : 'PROTEIN'
                }
                // for (let i = 0; i <seStr.length; i++) {
                //     if (str.includes(seStr[i])){
                //       v.sequenceType = 'DNA'
                //       v.sequenceSize = change[3].length + 'bp';
                //     }else{
                //       v.sequenceType = 'PROTEIN'
                //       v.sequenceSize = change[3].length + 'AA';
                //       return
                //     }
                //   }
                if(v.sequenceType === 'DNA'){
                  v.sequenceSize = change[3].length + 'bp';
                }else{
                  v.sequenceSize = change[3].length + 'AA';
                }

              }

              if (
                      change[0] === index &&
                      change[1] === "checkbox"
              ) {
                v.checkbox = change[3];
              }
            });
          }

          if (changes) {
             _this.list = changes
            //复制黏贴改变
            changes.filter((v, index) => {
              holeChange(v);
            });

            data.forEach(v => {
              v.flankingSequence5 = v.flankingSequence5.toUpperCase();
              v.flankingSequence3 = v.flankingSequence3.toUpperCase();
            })

            const [[rowIndex, colField, oldVal, newVal]] = changes
            const checkFieldList = ['flankingSequence5', 'flankingSequence3', 'sequence']
            if(['sequenceType', ...checkFieldList].includes(colField)){
              if(data[rowIndex].sequence && data[rowIndex].sequenceType === 'DNA' && !/^[ATCG]+$/g.test(data[rowIndex].sequence)){
                console.log(453)
                _this.$message.error('序列中包含非A/T/C/G，请确认是否正确');
              }
              ['flankingSequence5', 'flankingSequence3'].forEach(field => {
                if(data[rowIndex][field] && !/^[ATCG]+$/g.test(data[rowIndex][field])){
                  _this.$message.error('序列中包含非A/T/C/G，请确认是否正确');
                }
              })
            }
            data.forEach((v, index) => {
              if(v.sequenceType === 'DNA'){
                v.codonOptimization = false;
                }
              if(_this.hotSettings.data[_this.currentGene].geneServiceType === 'ET_GENE'){

                if(v.sequence.length > 3000){
                  _this.$message.error('序列长度超过ETgene产品服务范围，请选择其他基因合成服务');
                  v.geneServiceType = 'SPEED';
                  _this.hotSettings.data[_this.currentGene].geneServiceType = 'SPEED'
                }
                fetchRawCarrierList().then(({ data }) => this.spv = data)
              }
              if(v.sequenceType === 'PROTEIN'){
                  if(_this.cloneRadio === '1') data[_this.currentGene].codonOptimization = true
                  v.codonOptimization = true
                  v.sequenceSize = v.sequence.length + 'AA'
              }
              // const dnaFlag = this.hotSettings.data.some(({sequenceType}) => sequenceType === 'DNA')
              // const pFlag = this.hotSettings.data.some(({sequenceType}) => sequenceType === 'PROTEIN')
              // if(dnaFlag && pFlag) {
              //   v.codonOptimization = true
              // }
              _this.$set(_this.hotSettings.data, index, v);
            });
            this.loadData(data);
          }
        },
        afterValidate: function (isValid, value, row, prop, source) {
          if (!isValid) {
            if (prop === 'name') {
              _this.$message.error('基因名称限制输入“大小写英文字母”、“-”、“.”、“阿拉伯数字”')
            }
            if (prop === 'sequence') {
              _this.$message.error('基因序列必须由英文字母组成')
            }
            if (prop === 'flankingSequence5') {
              _this.$message.error('序列中包含非A/T/C/G，请确认是否正确');
            }
            if (prop === 'flankingSequence3') {
              _this.$message.error('序列中包含非A/T/C/G，请确认是否正确')
            }
          }
        },
        beforeOnCellMouseDown: function (el, val, html) {
          var tooltip = document.getElementById('tooltip')
          if (val.col === 3 && html.innerHTML.length > 12) {
            tooltip.innerHTML = html.innerHTML
            tooltip.style.display = 'block'
            var tooltipHeight = tooltip.offsetHeight
            tooltip.style.top = val.row * 42 - tooltipHeight + 30 + 'px'
          } else {
            tooltip.style.display = 'none'
          }
        }
      },
      single: {
        id: '',
        checkbox: false,
        index: 0,
        name: '',
        sequence: '',
        flankingSequence5: '',
        flankingSequence3: '',
        sequenceSize: '',
        sequenceType:'',
        geneServiceType: 'STANDARD',
        codonOptimization: false,
        expressionHost: '',
        optimizeLocationMax: '',
        optimizeLocationMix: '',
        avoidedRestrictionSites: '',
        conservedEnzymeDigestion: '',
        rawCarrierId: '',
        modify5: '',
        modify3: '',
        quantity: '1',
        deliveries: '',
        plasmidLevel: ''
      },
      editGeneLists: [],
      id: this.$route.query.id,
      unCompleteOrders: 0
    }
  },
  created() {
    this.changeCloneMethod()
    this.getConfig()
    this.init()
    this.getOrders()
  },
  computed: {
    ...mapState(['pageData'])
  },
  methods: {
    //基因合成速度切换
    geneServiceTypeChange(data){
      if(data === 'STANDARD'){
        let ETShow = document.getElementById('ETShow');
        ETShow.style.display = 'block';
        let ETShow1 = document.getElementById('ETShow1');
        ETShow1.style.display = 'none';
        this.hotSettings.data.forEach((v, index) => {
          if(v.sequenceType ==='PROTEIN'){
            v.codonOptimization = true
          }
        })
        fetchRawCarrierList().then(res => {
          this.spv = res.data
        })
      }
    },
    geneServiceTypeChange1(data){
      if(data === 'SPEED'){
        let ETShow = document.getElementById('ETShow');
        ETShow.style.display = 'block';
        let ETShow1 = document.getElementById('ETShow1');
        ETShow1.style.display = 'none';
        this.hotSettings.data.forEach((v, index) => {
          if(v.sequenceType ==='PROTEIN'){
            v.codonOptimization = true
          }
        })
        fetchRawCarrierList().then(res => {
          this.spv = res.data
        })
      }
    },
    geneServiceTypeChange2(data){
      if(data === 'ET_GENE'){
        this.hotSettings.data[this.currentGene].modify5 = ''
        this.hotSettings.data[this.currentGene].modify3 = ''
        this.hotSettings.data[this.currentGene].rawCarrierId = ''
        let ETShow = document.getElementById('ETShow');
        ETShow.style.display = 'none';
        let ETShow1 = document.getElementById('ETShow1');
        ETShow1.style.display = 'block';
        let arr = [];
        arr = this.hotSettings.data.map((item) => item)
        this.hotSettings.data.forEach((v, index) => {
          // v.codonOptimization = v.sequenceType !== 'DNA';
          if(v.sequenceType !== 'DNA'){
            v.codonOptimization = true
          }
          const dnaFlag = this.hotSettings.data.some(({sequenceType}) => sequenceType === 'DNA')
          const pFlag = this.hotSettings.data.some(({sequenceType}) => sequenceType === 'PROTEIN')
          if(dnaFlag && pFlag) {
            v.codonOptimization = true
          }
        })
        fetchRawCarrierList().then(({ data }) => this.spv = data)
        const len = arr.some((v) => v.sequence.length > 3000)
        if(len){
          this.$message.error('序列长度超过ETgene产品服务范围，请选择其他基因合成服务');
        }
        for( let i = 0; i < arr.length;i++){
          if(arr[i].sequence.length > 3000){
            arr[i].geneServiceType = 'SPEED';
            fetchRawCarrierList().then(res => {
              this.spv = res.data
            })
          }
        }




      }
    },
    init () {
      this.hotSettings.data = []
      if (!this.id) {
        this.initTable()
      } else {
        this.getDetails()
        this.getGeneLists()
      }
    },
    initTable () {
      this.hotSettings.data = []
      for (let i = 0; i < 10; i++) {
        let item = JSON.parse(JSON.stringify(this.single))
        item.index = i + 1
        this.hotSettings.data.push(item)
      }
    },
    // 基因详情
    getDetails () {
      geneOrdersDetails(this.id).then(res => {
        this.remark = res.data.value.remark
      })
    },
    // 基因包含的工单列表
    getGeneLists () {
      geneWorkOrder(this.id).then(res => {
        this.hotSettings.data = []
        res.data.map((item, index) => {
          let itx = {}
          item.index = index + 1
          item.checkbox = false
          Object.keys(this.single).map(key => {
            itx[key] = item[key]
          })
          if (item.plasmidLevel === '' && item.deliveries === '4ug') {
            itx.quantity = '1'
          } else {
            itx.quantity = '2'
          }
          // let seStr1 =  item.sequence;
          // for (let i = 0; i <seStr1.length; i++) {
          //   if (str.includes(seStr1[i])){
          //     item.sequenceType = 'DNA'
          //   }else{
          //     item.sequenceType = 'PROTEIN'
          //   }
          // }
          if(item.geneServiceType === 'STANDARD'){
            fetchRawCarrierList().then(res => {
              this.spv = res.data
            })
          }
          if(item.geneServiceType === 'SPEED'){
            fetchRawCarrierList().then(res => {
              this.spv = res.data
            })
          }
          if(item.geneServiceType === 'ET_GENE'){
            fetchRawCarrierList().then(res => {
              this.spv = res.data.filter(item => ['pUC57', 'pClone007'].includes(item))
            })
          }
          if(item.sequenceType === 'PROTEIN'){
            itx.sequenceSize = item.sequenceSize + 'AA'
          }else{
            itx.sequenceSize = item.sequenceSize + 'bp'
          }
          console.info('item-', item)

          itx.deliveries = this.pageData.qualitiesOptions.find((item2) => item2.title === item.deliveries)
          this.hotSettings.data.push(itx)
          this.useRows = this.hotSettings.data.length
          this.setTableHeight(this.useRows)
        })
        this.editGeneLists = res.data
      })
    },
    setTableHeight (rows) {
      // if (rows < 10 && rows > 0) {
      //   this.hotSettings.height = 41 * rows + 2
      // } else if (rows === 0) {
      //   this.hotSettings.height = 0
      // } else {
      //   this.hotSettings.height = 412
      // }
      if (rows === 0) {
        this.hotSettings.height = 0
      } else {
        this.hotSettings.height = 412
      }
    },
    // 合并单元格
    // bindMergeCells () {
    //   this.hotSettings.mergeCells = [{row: 0, col: 5, rowspan: this.addRows, colspan:1}]
    // },
    // 切换克隆定制信息radio
    changeCloneMethod () {
      // 验证引物序列输入
      const validText = (val) => {
        if (!val || val === '') return
        return !/^[a-zA-Z]+$/.test(val)
      }
      const _this = this;
      if (this.cloneRadio === '1') {
        this.hotSettings.columns = [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            validator(val, callback) {
              // if (!val) return callback(false)
              let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
              if (pattern.test(val)) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'sequence',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence5',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence3',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'sequenceType',
            source: ['DNA', 'PROTEIN'],
            // strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'sequenceSize',
            readOnly: true
          },
        ]
        this.hotSettings.single = [
          {
            id: '',
            checkbox: false,
            index: 0,
            name: '',
            sequence: '',
            flankingSequence5: '',
            flankingSequence3: '',
            sequenceSize: '',
            sequenceType:'',
            geneServiceType: 'STANDARD',
            codonOptimization: false,
            expressionHost: '',
            optimizeLocationMax: '',
            optimizeLocationMix: '',
            avoidedRestrictionSites: '',
            conservedEnzymeDigestion: '',
            rawCarrierId: '',
            modify5: '',
            modify3: '',
            quantity: '1',
            deliveries: '',
            plasmidLevel: ''
          }
        ]
        this.hotSettings.colWidths = ['33px', '50px', '109px', '120px','140px','140px','88px', '50px']
      } else {
        this.hotSettings.columns = [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            validator(val, callback) {
              // if (!val) return callback(false)
              let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
              if (pattern.test(val)) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'sequence',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence5',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence3',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'sequenceType',
            source: ['DNA', 'PROTEIN'],
            // strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'sequenceSize',
            readOnly: true
          },
          {
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
              let span = document.createElement('SPAN');
              span.innerText = '编辑'
              span.className = 'pointer text-primary'
              const data = _this.hotSettings.data[row]
              Handsontable.dom.addEvent(span, 'mousedown', function(event) {
                if (data.name !== '' && data.sequence !== '') {
                  _this.currentGene = row
                } else {
                  _this.$message.error('基因名称/基因序列不能为空')
                }
              });
              Handsontable.dom.empty(td)
              td.appendChild(span)
              return td
            }
          }
        ]
        this.hotSettings.single = [
          {
            id: '',
            checkbox: false,
            index: 0,
            name: '',
            sequence: '',
            flankingSequence5: '',
            flankingSequence3: '',
            sequenceSize: '',
            sequenceType:'',
            geneServiceType: 'STANDARD',
            codonOptimization: false,
            expressionHost: '',
            optimizeLocationMax: '',
            optimizeLocationMix: '',
            avoidedRestrictionSites: '',
            conservedEnzymeDigestion: '',
            rawCarrierId: '',
            modify5: '',
            modify3: '',
            quantity: '1',
            deliveries: '',
            plasmidLevel: ''
          }
        ]
        this.hotSettings.colWidths = ['33px', '50px', '92px', '110px','128px','128px','78px', '50px', '64px']
      }
    },
    changeCloneMethod1 (data) {
      // 切换时更改密码子优化选项
      // 验证引物序列输入
      const validText = (val) => {
        if (!val || val === '') return
        return !/^[a-zA-Z]+$/.test(val)
      }
      const _this = this;
      if (data === '1') {
        this.hotSettings.columns = [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            validator(val, callback) {
              // if (!val) return callback(false)
              let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
              if (pattern.test(val)) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'sequence',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence5',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence3',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'sequenceType',
            source: ['DNA', 'PROTEIN'],
            // strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'sequenceSize',
            readOnly: true
          },
        ]
        this.hotSettings.single = [
          {
            id: '',
            checkbox: false,
            index: 0,
            name: '',
            sequence: '',
            flankingSequence5: '',
            flankingSequence3: '',
            sequenceSize: '',
            sequenceType:'',
            geneServiceType: 'STANDARD',
            codonOptimization: false,
            expressionHost: '',
            optimizeLocationMax: '',
            optimizeLocationMix: '',
            avoidedRestrictionSites: '',
            conservedEnzymeDigestion: '',
            spv: '',
            modify5: '',
            modify3: '',
            quantity: '1',
            deliveries: '',
            plasmidLevel: ''
          }
        ]
        this.hotSettings.colWidths = ['33px', '50px', '109px', '120px','140px','140px','88px', '50px']
        this.hotSettings.data[this.currentGene].codonOptimization = this.hotSettings.data.some(({sequenceType}) => sequenceType === 'PROTEIN')
      }
    },
    changeCloneMethod2 (data) {
      // 验证引物序列输入
      const validText = (val) => {
        if (!val || val === '') return
        return !/^[a-zA-Z]+$/.test(val)
      }
      const _this = this;
      if (data === '2') {
        this.hotSettings.columns = [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            validator(val, callback) {
              // if (!val) return callback(false)
              let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
              if (pattern.test(val)) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'sequence',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence5',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'flankingSequence3',
            validator(val, callback) {
              let bool = validText(val)
              if (!bool) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'sequenceType',
            source: ['DNA', 'PROTEIN'],
            // strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'sequenceSize',
            readOnly: true
          },
          {
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
              let span = document.createElement('SPAN');
              span.innerText = '编辑'
              span.className = 'pointer text-primary'
              const data = _this.hotSettings.data[row]
              Handsontable.dom.addEvent(span, 'mousedown', function(event) {
                if (data.name !== '' && data.sequence !== '') {
                  console.log(row)
                  _this.currentGene = row
                } else {
                  _this.$message.error('基因名称/基因序列不能为空')
                }
              });
              Handsontable.dom.empty(td)
              td.appendChild(span)
              return td
            }
          }
        ]
        this.hotSettings.single = [
          {
            id: '',
            checkbox: false,
            index: 0,
            name: '',
            sequence: '',
            flankingSequence5: '',
            flankingSequence3: '',
            sequenceSize: '',
            sequenceType:'',
            geneServiceType: 'STANDARD',
            codonOptimization: false,
            expressionHost: '',
            optimizeLocationMax: '',
            optimizeLocationMix: '',
            avoidedRestrictionSites: '',
            conservedEnzymeDigestion: '',
            rawCarrierId: '',
            modify5: '',
            modify3: '',
            quantity: '1',
            deliveries: '',
            plasmidLevel: ''
          }
        ]
        this.hotSettings.colWidths = ['33px', '50px', '92px', '110px','128px','128px','78px', '50px', '64px']
      }
    },
    bindEdit () {
      const data = this.hotSettings.data
      if (data[0].name === '' || data[0].sequence === '') {
        this.$message.error('基因名称/基因序列不能为空')
      } else {
        this.currentGene = 0
      }
    },
    deleteSelect () {
      let bool = this.hotSettings.data.some((v) => v.checkbox);
      if (!bool) {
        return this.$message.warning("请选择要删除的数据");
      }
      this.$confirm("是否确认删除当前数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteMethods()
      })
    },
    deleteMethods() {
      this.hotSettings.data = this.hotSettings.data.filter(
        (v) => !v.checkbox
      );
      if (!this.hotSettings.data.length) {
        this.setTableHeight(0)
        return false
      }

      this.$message.success("删除成功");
      this.hotSettings.data.length &&
      this.hotSettings.data.forEach((v, index) => {
        v.index = index + 1;
      });
      this.setTableHeight(this.hotSettings.data.length)
      this.useRows = this.hotSettings.data.length
    },
    checkboxOnclick(evt) {
      this.hotSettings.data.forEach(
        (v) => (v.checkbox = evt.target.checked)
      )
    },
    // 清空表格
    clearTable () {
      this.$confirm('确定清除表格所有内容？', '提示', {
      }).then(() => {
        this.initTable()
      })
    },
    // 应用
    handleUsePrimers() {
      let len = this.hotSettings.data.length
      const geneNum = this.addRows
      // if (!len) return this.$message.warning('请创建基因信息后应用')

      if (geneNum > 500)
        return this.$message.warning('应用失败，应用数范围为0-500')
      if (this.baseMethods.isEmpty(geneNum))
        return this.$message.warning('应用行数不能为空')
      if (geneNum < len) {
        if (geneNum <= 0) {
          this.$message.warning('应用数据必须大于0')
        } else {
          this.$confirm('多于行数将删除，是否确认当前操作?').then(
                  (res) => {
                    this.hotSettings.data = this.hotSettings.data.slice(0, geneNum)
                    this.setTableHeight(geneNum)
                    this.useRows = geneNum
                  }
          )
        }
      } else if (geneNum > len) {
        let temp = { ...this.single }
        for (let index = len; index < geneNum; index++) {
          temp = JSON.parse(JSON.stringify(temp))
          temp.index = index + 1
          this.hotSettings.data.push(temp)
        }
        this.setTableHeight(geneNum)
        this.useRows = geneNum
        return this.$message.success('基因条数应用成功')
      }
    },
    getConfig () {
      geneConfig('表达宿主').then(res => {
        this.hosts = res.data
      })
      geneConfig('避免的酶切位点').then(res => {
        this.sites = res.data
      })
      fetchRawCarrierList().then(res => {
        this.spv = res.data
      })
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    onsubmit() {
      const {cloneRadio, remark} = this
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      const courseInfo = this.baseMethods.getLocalObj('courseInfo')
      let keys = Object.keys(this.single)
      console.log(keys,"keys");
      let sameKeys = keys.slice(9, keys.length)
      console.log(sameKeys,"sameKeys");
      let mustKeys = ['name', 'sequence', 'rawCarrierId', 'modify5', 'modify3']
      let currentIndex = 0
      let must = true
      this.hotSettings.data.map((item, index) => {

        const deliveries = item.deliveries

        try {
          if (item.deliveries){
            item.deliverNum = this.baseMethods.qualityConverter(
              deliveries.value,
              deliveries.unit,
              'ng'
            )
          }
        } catch (e) {
          console.info(e)
        }



        if (item.quantity === '1') {
          // item.deliveries = '4ug'
          item.deliverNum = 4000
          item.plasmidLevel = ''
        }

        console.info(item)

        item.deliveries = deliveries.value + deliveries.unit
        console.info('deliveries', item.deliveries)
        // 质检t1 - 需求1 - 230503 需求更新 数据存储时，其“交付类型”为“干粉”
        item.deliverType = 'DRYMEAL'




        let len = mustKeys.filter(key => item[key] !== '').length
        if (len === mustKeys.length) {
          currentIndex = index
          must = true
        }
        if (cloneRadio === '1') {
          if (item.name !== '' && item.sequence !== '') {
            sameKeys.map(key => {
              item[key] = this.hotSettings.data[currentIndex][key]
            })
          }
        }
        if (must) {
          let len = mustKeys.filter(key => item[key] !== '').length
          if (len > 0 && len < 5) {
            must = false
          }
        }
      })
      // 临时校验（后期优化）
      if(must === true){
        must = this.hotSettings.data.every((item) => {
          const len = mustKeys.filter(key => item[key] !== '').length
          if(len === 0 || len === 5){
            return true
          }else{
            return false
          }
        })
      }
      if (!must && this.hotSettings.data[this.currentGene].geneServiceType !== 'ET_GENE') {
        this.$message.error('请补充所有必填项')
        return
      }
      let geneLists = []
      let str = 'ATCG';
      this.hotSettings.data.map(item => {
        if (!this.baseMethods.isEmpty(item.name) && !this.baseMethods.isEmpty(item.sequence)) {
          item.discountCoefficient = 1
          geneLists.push(item)
        }
      })
      console.log('geneLists',geneLists)
      if (geneLists.length === 0) {
        this.$message.error('请至少添加一行数据')
        return
      }
      let arr = geneLists.map((v) => v)
     for(let i = 0; i < arr.length; i++){
      //  if(arr[i].spv === 'Other'){
      //    this.$message.error('载体为其他载体来源，订单无法提交');
      //    return
      //  }
       if(!/^[ATCG]+$/g.test(arr[i].sequence)){
         if(arr[i].sequenceType === 'DNA'){
           this.$message.error('基因信息填写有误');
           return false
         }
       }
       if(arr[i].flankingSequence5 !== '' && !/^[ATCG]+$/g.test(arr[i].flankingSequence5)){
        return this.$message.error('基因信息填写有误');
       }
       if(arr[i].flankingSequence3 !== '' && !/^[ATCG]+$/g.test(arr[i].flankingSequence3)){
        return this.$message.error('基因信息填写有误');
       }
     }




      let delIds = []
      if (geneLists.length < this.editGeneLists.length) {
        let ids = []
        let newIds = []
        this.editGeneLists.map(item => {
          ids.push(item.id)
        })
        geneLists.map(item => {
          newIds.push(item.id)
        })
        delIds = this.getArrDifference(ids, newIds)
      }
      const hotRef = this.$refs.hotTable.hotInstance
      hotRef.validateCells(async (valid) => {
        let amount = 0
        if (valid) {
          this.submitLoading = true
          geneLists.forEach(item => item.sequenceSize = item.sequenceSize.substring(0, item.sequenceSize.length - 2))
          const promises = geneLists.map(async item => {
            let deliveryNumberType = item.quantity === '1' ? 'STANDARD' : 'CUSTOMIZE'
            return await genePrice(1, item.geneServiceType, deliveryNumberType, item.sequence.toUpperCase(),item.flankingSequence5.toUpperCase(),item.flankingSequence3.toUpperCase())
          })
          const numFruits = await Promise.all(promises)
          numFruits.map((item, index) => {
            this.$set(geneLists[index], 'charges', item.data.pirce)
            this.$set(geneLists[index], 'totalPrice', item.data.pirce)
            this.$set(geneLists[index], 'assessmentFileName', item.data.name)
            this.$set(geneLists[index], 'assessmentFileUrl', item.data.ossUrl)
            this.$set(geneLists[index], 'degreeDifficulty', item.data.ratio)
          })

          if (geneLists.filter(item => !item.charges).length > 0) {
            amount = 0
          } else {
            geneLists.map(item => {
              amount += item.charges
            })
          }
          geneLists.forEach(item => {
            let proteinSequence = ''
            if(item.sequenceType === 'PROTEIN'){
              proteinSequence = item.sequence
            }
            item.proteinSequence = proteinSequence
          })


          let submitData = {
            id: this.id ? this.id : '',
            // baseId: courseInfo.base.id,
            geneSaveVMList: geneLists,
            submitFlag: false,
            geneOrderReturnFlag:false,
            priceFlag: amount ? false : true,
            amount: amount,
            remark: remark,
            customerId: memberInfo.id,
            clientGrade: memberInfo.level,
            customerEmail: memberInfo.email,
            // researchTeamId: memberInfo.researchGroup.id,
            // serviceSalesId: memberInfo.serveSeller.id,
            deleteGeneIdList: delIds
          }
          if (this.id) {
            submitData.id = this.id
          }

          console.info('geneLists', submitData)
          geneOrders(submitData).then(res => {
            this.submitLoading = false
            this.$message.success('提交成功')
            this.$router.push(`/tec/gene_confirm?id=${res.data.id}`)
          })
        } else {
          // this.$message.error('请检查数据格式')
        }
      })
    },
    // 获取基因序列长度
    getSequenceSize (value, index) {
      this.tableData[index].sequenceSize = value.length
    },
    // 检查引物序列格式
    checkSequence (str) {
      const checkStr = 'ATCGMRWSYKVHDBNIU'
      let checkFlag = true
      let arr = str.split('')
      for (let i in arr) {
        if (checkStr.indexOf(arr[i]) === -1) {
          checkFlag = false
        }
      }
      return checkFlag
    },
    // 最大输入三位
    inputGeneNum (value) {
      if (value.length >= 3) {
        this.addRows = value.substr(0, 3)
      }
    },
    // 查看载体图谱
    toMaps () {
      const spv = this.hotSettings.data[this.currentGene].rawCarrierId
      if (spv === '') {
        return this.$message.error('请选择一个载体')
      }
      // geneMaps(spv).then(res => {
        // if (!res.data) {
          return this.$message.warning('该载体没有对应的图谱信息')
        // }
        // window.open(res.data.mapsFile.visitedUrl)
      // })
    },
    // 未完成订单
    getOrders () {
      const searchIds = this.baseMethods.getSearchId()
      geneOrdersLists(0, 100, '', '', '', 'WAIT', searchIds[0], searchIds[1]).then(res => {
        this.unCompleteOrders = res.data.totalCount
      })
    },
    // 跳转到未处理订单
    toOrders () {
      this.$router.push('/user/gene?status=WAIT')
    }
  }
}
</script>
<style>
.active{
  color:red;
}
.no-active{
  color: #000;
}
#ETShow{
  display: block;
}
#ETShow1{
  display: none;
}
.zaiti .el-form-item__label{
  width: fit-content!important;
  text-align: left!important;
}
.suzhu .el-form-item__label{
  width: fit-content!important;
  text-align: left!important;
}
.weizhi .el-form-item__label{
  text-align: left!important;
  width:80px!important;
}

.zaiti,.kelong{
  margin-bottom: 0!important;
}
.kelong .el-form-item__label{
  text-align: left!important;
  width:100px!important;
}
.zaiti .el-form-item__content,
.kelong .el-form-item__content,
.suzhu .el-form-item__content,
.weizhi .el-form-item__content{
  margin-left: 0!important;
}
.abc .el-form-item__label{
  width: fit-content!important;
  text-align: left!important;
}
.kelong{
  margin-top: 15px;
}
.weizhi_one .el-form-item__label{
  width: fit-content!important;
  text-align: left!important;
}
.abc .el-col{
  margin-bottom: 10px;
  width: 35% !important;
}
.weizhi_one .weizhi_one1{
  margin-bottom: 10px;
  width: 35% !important;
}
.weizhi_one .weizhi_one2{
  width: 35% !important;
  /*margin-left: 110px;*/
}
.abc .el-form-item__label{
  /*margin-left: 12px;*/
  padding-right: 0;
}
.zaiti .el-input{
  width: 188px;
}
.abc .el-input{
  margin-left: -10px;
}
.abc .el-col:last-child{
  margin-bottom: 0;
  margin-left: 0!important;
}
.abc  .el-form-item__content{
  margin-left: 30px!important;
}
.ht_master .wtHolder{min-height: 84px!important;}
.handsontable .autocompleteEditor.handsontable{
  min-height: 100px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/tec/order_gene.vue